// extracted by mini-css-extract-plugin
module.exports = {"dialog":"AddressDialog_dialog__2_MAD"};